'use client';

import { create } from 'zustand';

export const useDictStore = create((set) => ({
    dict: {},
    setDict: (newDict) => set({ dict: newDict })
}));
